import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function FinalCTA() {
  const ref = useScrollAnimation();
  return <section className="w-full bg-[#0a0a0a] py-32 px-4 border-t border-[#1a1a1a] relative overflow-hidden" ref={ref} data-id="element-21">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-22">
        <div className="scroll-hidden" data-id="element-23">
          <div className="inline-block bg-red-500/10 border border-red-500/20 text-red-500 px-4 py-2 rounded-full font-bold text-sm mb-8" data-id="element-24">
            🔥 Esta oferta puede terminar en cualquier momento
          </div>

          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-25">
            Tu año de Arte, <br data-id="element-26" />
            <span className="text-[#F5C518]" data-id="element-27">resuelto.</span>
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-28">
            Dejá de improvisar. Empezá a disfrutar tus clases.
          </p>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-29">
            <a href="#comprar" onClick={e => {
            e.preventDefault();
            const el = document.getElementById('comprar');
            if (el) {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} className="block w-full bg-[#F5C518] text-black px-8 py-5 rounded-xl font-black text-xl md:text-2xl hover:bg-[#fcd34d] hover:scale-105 transition-all duration-300" data-id="element-30">
              🎨 → QUIERO MI PROFEPACK AHORA
            </a>
          </div>

          <div className="flex items-center justify-center gap-2 text-green-400 font-medium mb-8" data-id="element-31">
            <span className="relative flex h-3 w-3" data-id="element-32">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-33"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-34"></span>
            </span>
            +2.000 docentes ya lo tienen
          </div>

          <p className="text-gray-500 text-sm font-medium" data-id="element-35">
            Acceso inmediato • Pago seguro • Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}